import { render, staticRenderFns } from "./FormC.vue?vue&type=template&id=48cbd4bf&scoped=true&"
import script from "./FormC.vue?vue&type=script&lang=js&"
export * from "./FormC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbd4bf",
  null
  
)

export default component.exports